"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fix = exports.psi = exports.converge = exports.chain = exports.substitution = exports.compose2 = exports.flip = exports.duplication = exports.thrust = exports.apply = exports.constant = exports.identity = void 0;
const identity = (a) => a;
exports.identity = identity;
const constant = (a) => a;
exports.constant = constant;
const apply = (f, a) => f(a);
exports.apply = apply;
const thrust = (a, f) => f(a);
exports.thrust = thrust;
const duplication = (f, a) => f(a, a);
exports.duplication = duplication;
const flip = (f, b, a) => f(a, b);
exports.flip = flip;
const compose2 = (f, g, a) => f(g(a));
exports.compose2 = compose2;
const substitution = (f, g, a) => f(a, g(a));
exports.substitution = substitution;
const chain = (f, g, b) => f(g(b), b);
exports.chain = chain;
const converge = (f, g, h, a) => f(g(a), h(a));
exports.converge = converge;
const psi = (f, g, a1, a2) => f(g(a1), g(a2));
exports.psi = psi;
const fix = (f, a) => f(a);
exports.fix = fix;
//# sourceMappingURL=combinators.js.map